import { httpV2 } from "../http.js";

const base = "/task-occurrences";

const TaskOccurrencesService = {
  list: (params = {}) => httpV2.get(base, { params }),

  materialize: (body) => httpV2.post(`${base}/materialize`, body),

  skip: (body) => httpV2.post(`${base}/skip`, body),

  // Delete a still-virtual occurrence and all future occurrences of its rule.
  deleteFuture: (body) => httpV2.post(`${base}/delete-future`, body),

  // End the rule from today and purge upcoming new concretes only.
  deleteAll: (body) => httpV2.post(`${base}/delete-all`, body),
};

export default TaskOccurrencesService;
